export default __webpack_public_path__ + "static/media/2.c42b79d4.jpg";